import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-y-auto h-[80%]"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "flex justify-center"
}
const _hoisted_4 = { class: "flex justify-end gap-2" }

import { useNotes } from '@/store/notes';
  import { onMounted, ref } from 'vue';
  import { localstorageGet, localstorageSet } from '@/helpers/helper';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorNotes',
  props: {
    country: {}
  },
  setup(__props: any) {

  const NotesService = useNotes();
  const props = __props;
  onMounted(async () => {
    await NotesService?.getNotes(props.country);
  });
  const visibleNotes = ref<boolean>(!(localstorageGet('readNews') === 'true'));

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: visibleNotes.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visibleNotes).value = $event)),
    header: "Delivery Information",
    style: { width: '90%' },
    position: _ctx.position,
    modal: true,
    closable: false,
    draggable: false
  }, {
    default: _withCtx(() => [
      (_unref(NotesService).notes.value?.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              innerHTML: _unref(NotesService).notes.value?.value
            }, null, 8, _hoisted_2)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-teal-500" }, null, -1)
          ]))),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          type: "button",
          label: "Ok",
          onClick: _cache[0] || (_cache[0] = 
          () => {
            visibleNotes.value = false;
            _unref(localstorageSet)('readNews', true);
          }
        )
        })
      ])
    ]),
    _: 1
  }, 8, ["visible", "position"]))
}
}

})